export default "__VITE_ASSET__CrjK7l_W__"